import { useNavigate } from "react-router-dom";
import { useEffect } from "react";
import { Box, Card, Stack, Typography } from "@mui/material";

import Logo from "../../components/Logo";
import LoginForm from "./LoginForm";
import { useAppContext } from "../../context/AppContext";

const Login = () => {
  const navigate = useNavigate();
  const { loggedInUser } = useAppContext();

  useEffect(() => {
    if (loggedInUser) {
      navigate("/");
    }
  }, [loggedInUser, navigate]);

  return (
    <Box sx={{ position: "relative", width: "100%", maxWidth: 980, mx: "auto" }}>
      {/* Blue Poster / Hero Panel */}
      <Box
        sx={{
          position: "relative",
          borderRadius: "28px",
          background: "linear-gradient(135deg, #4d7cf7 0%, #2f5fdb 45%, #16296b 100%)",
          minHeight: { xs: "auto", md: 460 },
          overflow: "hidden",
          boxShadow: "0 25px 70px rgba(22, 41, 107, 0.45)",
          px: { xs: 4, md: 7 },
          py: { xs: 6, md: 0 },
          pr: { xs: 4, md: "380px" },
          display: "flex",
          alignItems: "center",
        }}
      >
        {/* Decorative circles matching the logo's blue / gold / red dots */}
        <Box sx={{ position: "absolute", left: "-12%", bottom: "-30%", width: 380, height: 380, borderRadius: "50%", background: "rgba(255,255,255,0.08)" }} />
        <Box sx={{ position: "absolute", left: "2%", bottom: "-14%", width: 260, height: 260, borderRadius: "50%", background: "rgba(255,255,255,0.10)" }} />
        <Box sx={{ position: "absolute", right: { xs: "30%", md: "44%" }, top: "10%", width: 140, height: 140, borderRadius: "50%", background: "#e8a53d", opacity: 0.85 }} />
        <Box sx={{ position: "absolute", right: { xs: "16%", md: "32%" }, top: "62%", width: 90, height: 90, borderRadius: "50%", background: "#d93025", opacity: 0.85 }} />
        <Box sx={{ position: "absolute", right: { xs: "42%", md: "52%" }, top: "40%", width: 60, height: 60, borderRadius: "50%", background: "#ffffff", opacity: 0.3 }} />

        <Stack spacing={2} sx={{ position: "relative", zIndex: 1, color: "#fff" }}>
          <Typography
            sx={{
              fontWeight: 900,
              fontSize: { xs: "2.1rem", md: "2.6rem" },
              letterSpacing: "-0.02em",
              lineHeight: 1.1,
              textShadow: "0 4px 12px rgba(0,0,0,0.15)",
            }}
          >
            WELCOME
          </Typography>
          <Typography
            sx={{
              fontWeight: 700,
              fontSize: "0.95rem",
              letterSpacing: "0.1em",
              color: "rgba(255,255,255,0.85)",
            }}
          >
            To TheReportStack Dashboard
          </Typography>
          <Typography sx={{ fontSize: "0.95rem", color: "rgba(255,255,255,0.7)", lineHeight: 1.7, maxWidth: 380, fontWeight: 500 }}>
            TheReportStack is a leading automation dashboard providing real-time insights,
            unified reporting, and intelligent analytics for all your test cycles.
          </Typography>
        </Stack>
      </Box>

      {/* Floating Sign-in Card */}
      <Card
        sx={{
          position: { xs: "relative", md: "absolute" },
          top: { md: "50%" },
          right: { md: -24, lg: -32 },
          transform: { md: "translateY(-50%)" },
          mt: { xs: -6, md: 0 },
          mx: { xs: "auto", md: 0 },
          width: { xs: "90%", sm: 420 },
          borderRadius: "20px",
          boxShadow: "0 20px 60px rgba(15, 23, 42, 0.25)",
          border: "1px solid rgba(255,255,255,0.6)",
          p: { xs: 4, md: 5 },
          zIndex: 2,
        }}
      >
        <Stack alignItems="center" spacing={3} sx={{ width: "100%" }}>
          <Logo width={230} />

          <Stack spacing={0.5} sx={{ textAlign: "center", width: "100%" }}>
            <Typography
              variant="h3"
              sx={{
                fontWeight: 800,
                fontSize: "1.65rem",
                color: "#1e1b4b",
                letterSpacing: "-0.01em",
              }}
            >
              Log In
            </Typography>
            <Typography sx={{ color: "#64748b", fontSize: "0.9rem", fontWeight: 500 }}>
              Enter your credentials to continue
            </Typography>
          </Stack>

          <Box sx={{ width: "100%" }}>
            <LoginForm />
          </Box>
        </Stack>
      </Card>
    </Box>
  );
};

export default Login;
